"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionBidOfferDtoSignatureStatusEnum = exports.AuctionBidOfferDtoStatusEnum = void 0;
exports.instanceOfAuctionBidOfferDto = instanceOfAuctionBidOfferDto;
exports.AuctionBidOfferDtoFromJSON = AuctionBidOfferDtoFromJSON;
exports.AuctionBidOfferDtoFromJSONTyped = AuctionBidOfferDtoFromJSONTyped;
exports.AuctionBidOfferDtoToJSON = AuctionBidOfferDtoToJSON;
exports.AuctionBidOfferDtoToJSONTyped = AuctionBidOfferDtoToJSONTyped;
/**
 * @export
 */
exports.AuctionBidOfferDtoStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * @export
 */
exports.AuctionBidOfferDtoSignatureStatusEnum = {
    OfferorSignPending: 'offeror_sign_pending',
    OfferorSigned: 'offeror_signed',
    OffereeSignPending: 'offeree_sign_pending',
    OffereeSigned: 'offeree_signed'
};
/**
 * Check if a given object implements the AuctionBidOfferDto interface.
 */
function instanceOfAuctionBidOfferDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    return true;
}
function AuctionBidOfferDtoFromJSON(json) {
    return AuctionBidOfferDtoFromJSONTyped(json, false);
}
function AuctionBidOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'signatureStatus': json['signatureStatus'],
        'offerPrice': json['offerPrice'],
        'depositAmount': json['depositAmount'] == null ? undefined : json['depositAmount'],
        'totalPaid': json['totalPaid'] == null ? undefined : json['totalPaid'],
    };
}
function AuctionBidOfferDtoToJSON(json) {
    return AuctionBidOfferDtoToJSONTyped(json, false);
}
function AuctionBidOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
        'signatureStatus': value['signatureStatus'],
        'offerPrice': value['offerPrice'],
        'depositAmount': value['depositAmount'],
        'totalPaid': value['totalPaid'],
    };
}
